module.exports = __webpack_public_path__ + "img/coupon_45.4bcfda22.png";